/* eslint-disable react/jsx-props-no-spreading */

// import Button from 'components/Button';
import H3 from 'components/H3';
import H4 from 'components/H4';
import React from 'react';
// import { useHistory } from 'react-router';
import styled from 'styled-components';

const Img = styled.img`
    width: 110px;
    height: 110px;
    margin-right: 35px;

    @media only screen and (max-width: 1024px) {
        width: 60px;
        height: 60px;
    }
`;

const Div = styled.div`
    @media only screen and (min-width: 1024px) {
        display: none !important;
    }
`;

const NoData = () => {
    // const history = useHistory();

    // const handleAdd = () => {
    //     history.push('/doc-manage/add-document');
    // };

    return (
        <div className="d-flex position-absolute flex-row align-items-center justify-content-center" style={{marginTop:'30vh',width:'100%'}}>
            <Img src={require("_assets/images/cherry-list-is-empty.png").default} />
            <div className="d-flex flex-column">
                <H3 className="margin-bottom-10">Sorry we couldn’t find any result</H3>
                <H4 className="d-flex flex-column">
                    Try adjusting your search or filter to find
                    <span>what you’re looking for.</span>
                </H4>
                <Div className="margin-top-25">
                    {/* <Button primary typeAdd handleRoute={handleAdd}>
                        Add Documentation
                    </Button> */}
                </Div>
            </div>
        </div>
    )
}

export default NoData;